import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  SelectableSettings,
  SelectableMode,
} from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import {
  process,
  State,
  toODataString,
  SortDescriptor,
} from '@progress/kendo-data-query';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import {
  table_pageSize,
  Templates,
} from '../../../shared/constants/templatesNames';
import {
  FilterableSettings,
  DataBindingDirective,
  GridDataResult,
  PageChangeEvent,
  DataStateChangeEvent,
  GridComponent,
} from '@progress/kendo-angular-grid';
import { Helper } from '../../../core/helpers/helper';
import { Validations } from '../../../shared/constants/validations';
import { SharedService } from '../../../shared/shared.service';
import { MeterService } from '../../../core/services/meter.services';
import { LoaderService } from '../../../core/services/loader.service';
import { Roles, SweetAlertIcon } from '../../../shared/constants/enum';
import { RpBulkUpoadComponent } from '../../../shared/components/rp-bulkupload/rp-bulkupload.component';
import { NavigationEnd, Router } from '@angular/router';
import { filter as rxFilter } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { PdfexportService } from '../../../core/services/pdfexport.service';
@Component({
  selector: 'app-meters-database',
  templateUrl: './meters-database.component.html',
  styleUrl: './meters-database.component.scss',
  standalone: false,
})
export class MetersDatabaseComponent {
  @ViewChild('pdfGrid') public hiddenGrid: GridComponent | undefined;
  public selectableSettings: SelectableSettings = {
    mode: 'multiple',
    checkboxOnly: true,
  };
  Roles = Roles;
  reason: any;
  modalRefReasons!: BsModalRef;
  reasonError: boolean = false;
  modalRef!: BsModalRef;
  public meterState: any = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  userId: any;
  config: any = {
    backdrop: true,
    ignoreBackdropClick: true,
  };
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective | undefined;
  public pageSize = 10;
  public skip = 0;
  totalMasterCount: number = 0;
  currentPage: number = 1;
  meterDBlistList: any[] = [];
  public sort: SortDescriptor[] = [];
  public meterDBgridData: GridDataResult = { data: [], total: 0 };
  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] };
  mySelectionMeter: any = [];
  orderByQuery: string = '';
  queryString: string = '';
  searchedValue: any = '';
  public buttonCount = 5;

  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  public pageSizes = table_pageSize.pageSizes;

  public previousNext = true;
  breadCrumbItems: Array<{}> | undefined;
  modelRef_1!: BsModalRef;
  Macregex = /^[0-9A-F]+$/;
  //  Macregex = /^(?=.*[0-9])(?=.*[A-F])[0-9A-F]+$/;
  regex = /^[A-Z0-9]*$/;
  IsWiredMacregex = /^[0-9]+$/;
  SerialIswired = /^[A-Z0-9]+$/;
  submitted: boolean = false;
  configData: any = [];
  meterUtilities: any[] = [];
  selectedutlity: any;
  currentUser: any;
  role: any;
  iswirdeCommunication: boolean = false;
  private lastAppliedMacAddress: string | null = null;

  Umd_Validations = Validations.UmdCreatePage;
  createUMDForm!: UntypedFormGroup;
  constructor(
    private modalService: BsModalService,
    private sharedService: SharedService,
    private formBuilder: UntypedFormBuilder,
    private meterService: MeterService,
    private router: Router,
    private loaderService: LoaderService,
    private pdfexportService: PdfexportService,
    private cd: ChangeDetectorRef,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') ?? '');
    this.userId = this.currentUser?.currentUserRoleDetails.userId;
    this.role = this.currentUser?.currentUserRoleDetails.role;
    //this.getAllConfigData();
    this.breadCrumbItems = [{ label: 'Meters Database' }];
    this.router.events
      .pipe(rxFilter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (this.router.url.startsWith('/metersDatabase')) {
          this.applyNotificationFilterIfAny();
        }
      });
  }
  onlynumber = /^\d+$/;
  ngOnInit(): void {
    this.createUMDForm = this.formBuilder.group({
      utilityMasterId: [, Validators.required],
      isWiredCommunicationDevice: [false],
      deviceId: [''],
      meterSerialNo: [
        '',
        [
          Validators.required,
          Validators.pattern(this.regex),
          Validators.maxLength(16),
          Validators.minLength(7),
        ],
      ],
      supplierId: [null, Validators.required],
      macAddress: [
        '',
        [
          Validators.required,
          Validators.pattern(this.Macregex),
          Validators.maxLength(16),
          Validators.minLength(16),
        ],
      ],
    });
    this.applyNotificationFilterIfAny();
  }
  private applyNotificationFilterIfAny(): void {
    const macAddress = this.getNotificationMacAddress();
    if (macAddress) {
      this.applyMacAddressFilter(macAddress);
    } else {
      this.getAllDBmeters();
    }
  }

  private normalizeMacAddress(value: string): string {
    return value.replace(/[^0-9a-fA-F]/g, '').toUpperCase();
  }

  private getNotificationMacAddress(): string | null {
    const navigationState =
      this.router.getCurrentNavigation()?.extras?.state || history.state;

    if (!navigationState || navigationState.from !== 'notifications') {
      return null;
    }

    const info =
      navigationState.info ?? navigationState.data ?? navigationState;
    if (!info) {
      return null;
    }

    if (typeof info === 'string') {
      return info.trim() ? this.normalizeMacAddress(info.trim()) : null;
    }

    const infoPayload = info.data ?? info.payload ?? info.notification ?? info;
    const macAddress =
      infoPayload.macAddress ||
      infoPayload.mac_address ||
      infoPayload.deviceMacAddress ||
      infoPayload.deviceMac ||
      infoPayload.mac;

    if (typeof macAddress === 'string' && macAddress.trim().length > 0) {
      return this.normalizeMacAddress(macAddress.trim());
    }

    const textSource =
      infoPayload.description || infoPayload.message || infoPayload.title || '';
    const match = String(textSource).match(/[0-9A-F]{16}/i);
    return match ? this.normalizeMacAddress(match[0]) : null;
  }

  private applyMacAddressFilter(macAddress: string): void {
    if (this.lastAppliedMacAddress === macAddress) {
      return;
    }
    this.lastAppliedMacAddress = macAddress;
    this.searchedValue = '';
    this.searchModifiedData = '';
    this.cd.detectChanges();
    this.skip = 0;
    this.currentPage = 1;
    this.meterState.filter = {
      logic: 'and',
      filters: [
        {
          field: 'macAddress',
          operator: 'eq',
          value: macAddress,
        },
      ],
    };
    this.filter = this.meterState.filter;
    this.onMeterFilterChange(this.meterState.filter);
  }
  getAllDBmeters() {
    this.loaderService.setLoading(true);
    this.meterService
      .getAllMetersDatabase({
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        searchTerm: this.searchedValue,
        filter: this.queryString,
        orderBy: this.orderByQuery,
      })
      .subscribe({
        next: (res) => {
          console.log(res);
          if (res.statusCode == 200) {
            this.loaderService.setLoading(false);
            console.log(res);
            this.meterDBlistList = [...res.data.items];
            this.pageSize = res.data.pageSize;
            this.totalMasterCount = res.data.totalCount;
            console.log(this.totalMasterCount);
            this.loadMterConfig();
          }
        },
        error: (err) => {
          this.loaderService.setLoading(false);
          console.log(err);
        },
      });
  }
  metersDbExportData: any = [];
  exportAll() {
    this.loaderService.setLoading(true);
    this.meterService
      .getAllMetersDatabase({
        pageIndex: this.currentPage,
        pageSize: this.totalMasterCount,
        searchTerm: this.searchedValue,
        filter: this.queryString,
        orderBy: this.orderByQuery,
      })
      .subscribe({
        next: (res) => {
          console.log(res);
          this.metersDbExportData = [];
          if (res.data.items.length > 0) {
            this.metersDbExportData = [...res.data.items];
            const transformedData = this.metersDbExportData.map(
              (item: any) => ({
                Utility: item.currentUtilityType,
                'Device Sr No': item.meterSerialNo,
                'Mac Address': item.macAddress,
                'Is Wired': item.isWiredCommunicationDevice ? 'Yes' : 'No',
                'Device Id ': item.deviceId,
                'Requested Project': item.requestProject,
                Status: item.approvalStatus,
                'Bulk Approve Status': item.bulkStatus,
                'Rejected Reason': item.failedReason,
              }),
            );
            this.loaderService.setLoading(false);
            this.pdfexportService.downloadExcel(
              transformedData,
              'meters DataBase',
            );
          } else {
            this.loaderService.setLoading(false);
            this.sharedService.showMessageDialog(
              'No data to display',
              '',
              SweetAlertIcon.ERROR,
            );
          }
        },
        error: (err) => {
          this.loaderService.setLoading(false);
          this.sharedService.showMessageDialog(
            'No data to display',
            '',
            SweetAlertIcon.ERROR,
          );
          console.log(err);
        },
      });
  }
  getAllConfigData(): void {
    let payload = ['utilities', 'suppliers'];
    // this.loaderService.setLoading(true);
    this.sharedService.getAllConfigData(payload).subscribe((res) => {
      if (
        res.statusCode === 200 &&
        res.message === 'Config data retrieved successfully.'
      ) {
        this.configData = res.data;
        this.meterUtilities = this.getMeterUtilities(
          this.configData?.utilities,
        );

        this.loaderService.setLoading(false);
      }
    });
  }

  private getMeterUtilities(utilities: any[] = []): any[] {
    return utilities.filter(
      (utility: any) => utility?.name?.toString().trim().toLowerCase() !== 'ev',
    );
  }

  createDBmeters(NewMeters: any) {
    this.getAllConfigData();
    this.submitted = false;
    this.createUMDForm.reset();
    this.selectedutlity = null;
    this.modelRef_1 = this.modalService.show(NewMeters, {
      class: 'modal-dialog-centered',
      backdrop: 'static', //
    });
  }

  saveMeterDataBase() {
    // console.log('NewMeters');
    this.submitted = true;
    this.loaderService.setLoading(true);
    if (this.createUMDForm.invalid) {
      this.loaderService.setLoading(false);
      return;
    } else {
      let request = {
        utilityMasterId: this.selectedutlity.id,
        macAddress: this.createUMDForm.get('macAddress')?.value,
        meterSerialNo: this.createUMDForm.get('meterSerialNo')?.value,
        currentUtilityType: this.selectedutlity.name,
        isWiredCommunicationDevice:
          this.createUMDForm.get('isWiredCommunicationDevice')?.value ?? false,
        deviceId: this.createUMDForm.get('deviceId')?.value,
        supplierId: this.createUMDForm.get('supplierId')?.value,
      };
      console.log(request);
      this.meterService.createMeterDataBase(request).subscribe({
        next: (res) => {
          if (res.statusCode == 200) {
            console.log(res);
            this.modelRef_1.hide();
            this.getAllDBmeters();
            this.sharedService.showMessageDialog(
              'Success',
              res.message,
              SweetAlertIcon.SUCCESS,
            );
            this.loaderService.setLoading(false);
          }
        },
        error: (err) => {
          const errorMsg = err.error?.message ? err.error.message : err.message;

          this.sharedService.showMessageDialog(
            'Error',
            errorMsg,
            SweetAlertIcon.ERROR,
          );

          console.log(err);
          this.loaderService.setLoading(false);
        },
      });
    }
  }
  waterTypeItems: any = [];
  changeUtility(event: any) {
    console.log(event);
    this.selectedutlity = event;
    this.iswirdeCommunication = false;
    this.createUMDForm.get('isWiredCommunicationDevice')?.setValue(false);
    this.createUMDForm.get('supplierId')?.setValue(null);
    if (event == undefined) {
      this.waterTypeItems = [];
    } else {
      this.waterTypeItems = [];
      this.waterTypeItems = this.configData?.suppliers.filter((item: any) => {
        return item.master.name.toLowerCase() === event.name.toLowerCase();
      });
    }
    console.log(this.waterTypeItems);
  }

  onCheckboxChange(event: any) {
    console.log(event.target.checked);
    this.iswirdeCommunication = event.target.checked;
    //console.log(this.iswirdeCommunication);

    if (event.target.checked) {
      this.f['macAddress'].setValidators([
        Validators.required,
        Validators.pattern(this.IsWiredMacregex),
        Validators.maxLength(7),
        Validators.minLength(7),
      ]);
      this.f['meterSerialNo'].setValidators([
        Validators.required,
        Validators.pattern(this.SerialIswired),
        Validators.maxLength(7),
        Validators.minLength(7),
      ]);
      this.f['deviceId'].setValidators([
        Validators.required,
        Validators.pattern(this.onlynumber),
        Validators.maxLength(7),
      ]);
      this.f['meterSerialNo'].updateValueAndValidity();
      this.f['macAddress'].updateValueAndValidity();
      this.f['deviceId'].updateValueAndValidity();
    } else {
      this.f['macAddress'].setValidators([
        Validators.required,
        Validators.pattern(this.Macregex),
        Validators.maxLength(16),
        Validators.minLength(16),
      ]);
      this.f['meterSerialNo'].setValidators([
        Validators.required,
        Validators.pattern(this.regex),
        Validators.maxLength(16),
        Validators.minLength(7),
      ]);
      this.f['macAddress'].updateValueAndValidity();
      this.f['meterSerialNo'].updateValueAndValidity();
      this.f['deviceId'].clearValidators(); // Remove validators
      this.f['deviceId'].setValue('', { emitEvent: false });
      this.f['deviceId'].updateValueAndValidity({
        onlySelf: true,
        emitEvent: false,
      });
    }
  }
  get f() {
    return this.createUMDForm.controls;
  }

  public showTooltip(e: MouseEvent): void {
    const element = e.target as HTMLElement;
    // Check if the element is a table cell
    if (element.nodeName === 'TD') {
      const cellValue = element.innerText.trim();

      // Only show the tooltip if the cell is not empty, null, or ''
      if (cellValue && !element.closest('.no-tooltip')) {
        this.tooltipDir?.toggle(element);
      } else {
        this.tooltipDir?.hide();
      }
    } else if (element.classList.contains('k-column-title')) {
      this.tooltipDir?.toggle(element);
    } else {
      this.tooltipDir?.hide();
    }
  }

  onSortChange(sort: SortDescriptor[]): void {
    this.meterState.sort = sort;
    console.log(this.meterState.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.meterState.sort,
    );

    this.orderByQuery = orderByQuery;
    this.getAllDBmeters();
    //this.getAllMeterConfigurations();
  }

  protected meterConfigPageChange({ skip, take }: PageChangeEvent): void {
    console.log('>>>', skip, take);
    this.mySelectionMeter = [];
    this.skip = skip;
    this.pageSize = take;
    this.currentPage = Math.floor(skip / take) + 1;
    console.log('currentpage', Math.floor(skip / take) + 1);

    this.getAllDBmeters();

    // this.loadMterConfig();
  }

  protected dataStateChange(state: DataStateChangeEvent): void {
    console.log('saAK', JSON.stringify(state.filter));
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    console.log('datastatechange' + JSON.stringify(this.filter));
  }
  public selectionChanged(selection: any) {
    // Handle deselected rows
    selection.deselectedRows.forEach((row: any) => {
      const index = this.mySelectionMeter.findIndex(
        (selectedRow: any) => selectedRow.id === row.dataitem?.id,
      );
      if (index > -1) {
        this.mySelectionMeter.splice(index, 1);
      }
    });

    // Handle selected rows
    selection.selectedRows.forEach((row: any) => {
      if (!this.isMasterRowSelected(row.dataItem)) {
        this.mySelectionMeter.push(row.dataItem);
      }
    });

    console.log(this.mySelectionMeter);
  }

  public isMasterRowSelected = (rowArg: any) => {
    return this.mySelectionMeter.some((row: any) => row.id === rowArg.id);
  };

  private loadMterConfig(): void {
    const state: State = {
      take: this.pageSize,
      sort: this.sort,
      filter: {
        logic: 'and',
        filters: [],
      } as CompositeFilterDescriptor, // Providing a valid filter
    };

    const processedData = process(this.meterDBlistList, state);
    this.meterDBgridData = {
      data: processedData.data,
      total: this.totalMasterCount,
    };

    this.meterDBgridData.data = this.meterDBgridData?.data.map((item) => {
      return {
        ...item,
        is_wired: item.isWiredCommunicationDevice ? 'Yes' : 'No',
      };
    });

    console.log(this.meterDBgridData);
  }

  onMeterExport() {
    if (this.meterDBgridData.data.length > 0) {
      setTimeout(() => {
        this.hiddenGrid?.saveAsExcel();
      }, 1000);
    }
  }
  isEditRestricted(dataItem: any): boolean {
    const utilityName = dataItem?.currentUtilityType?.trim().toLowerCase();
    const currentRole = this.role?.trim();

    return (
      (currentRole === Roles.SUPERADMIN || currentRole === Roles.SUPERUSER) &&
      utilityName === 'ev'
    );
  }

  goToEditMeters(dataItem: any) {
    this.router.navigate(['/metersDatabase/EditMeters'], {
      state: { MetersId: dataItem.id },
    });
  }
  deleteMeterDB(dataItem: any): void {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        showCancelButton: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.meterService.deleteMeterDB(dataItem.id).subscribe({
            next: (response) => {
              swalWithBootstrapButtons.fire(
                'Deleted!',
                'Meter has been deleted successfully.',
                'success',
              );
              this.getAllDBmeters();
            },
            error: (error) => {
              console.error('Delete failed:', error);
              swalWithBootstrapButtons.fire(
                'Error!',
                'Failed to delete meter.',
                'error',
              );
            },
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          swalWithBootstrapButtons.fire(
            'Cancelled',
            'Meter is safe',
            'error',
          );
        }
      });
  }

  bulkPaarove() {
    if (this.mySelectionMeter.length > 0) {
      this.loaderService.setLoading(true);
      console.log(this.mySelectionMeter);
      let filterStatusIds = this.mySelectionMeter
        .filter((item: any) => item.approvalStatus === 'AgentMapped')
        .map((item: any) => item.id);
      console.log(filterStatusIds);
      let request = {
        meterIds: filterStatusIds,
      };
      if (filterStatusIds.length > 0) {
        this.meterService.bulkApprove(request).subscribe({
          next: (res) => {
            if (res.statusCode == 200) {
              this.getAllDBmeters();
              this.sharedService.showMessageDialog(
                res.message,
                '',
                SweetAlertIcon.SUCCESS,
              );
              this.loaderService.setLoading(false);
            }
          },
          error: (err) => {
            console.log(err);
            this.loaderService.setLoading(false);

            // Check if backend returned an error.message
            const errorMsg =
              err.error?.message ||
              'Something went wrong. Please try again later.';

            this.sharedService.showMessageDialog(
              errorMsg,
              '',
              SweetAlertIcon.ERROR,
            );
          },
        });
      } else {
        this.loaderService.setLoading(false);
        this.sharedService.showMessageDialog(
          'Please select at least one record to continue(Status as a AgentMapped).',
          '',
          SweetAlertIcon.ERROR,
        );
      }
    } else {
      this.loaderService.setLoading(false);
      this.sharedService.showMessageDialog(
        'Please select at least one record to continue.',
        '',
        SweetAlertIcon.ERROR,
      );
    }
  }
  approval(dataItem: any) {
    this.loaderService.setLoading(true);
    let request = {
      meterId: dataItem.id,
      userID: this.userId,
      macAddress: dataItem.macAddress,
      mapType: dataItem?.approvalStatus,
    };

    this.meterService.approveMetersDB(request).subscribe({
      next: (res) => {
        if (res.statusCode === 200) {
          this.getAllDBmeters();
          this.sharedService.showMessageDialog(
            res.message,
            '',
            SweetAlertIcon.SUCCESS,
          );
          this.loaderService.setLoading(false);
        }
      },
      error: (err) => {
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message || 'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR,
        );
      },
    });
  }
  //approval(dataItem: any) {}
  reject(dataItem: any) {
    this.loaderService.setLoading(true);
    let request = {
      meterId: dataItem.id,
      userID: this.userId,
      macAddress: dataItem.macAddress,
      mapType: dataItem?.approvalStatus,
      reason: this.reason,
    };

    this.meterService.rejectMetersDB(request).subscribe({
      next: (res) => {
        if (res.statusCode === 200) {
          this.getAllDBmeters();
          this.sharedService.showMessageDialog(
            res.message,
            '',
            SweetAlertIcon.SUCCESS,
          );
          this.loaderService.setLoading(false);
        }
      },
      error: (err) => {
        console.log(err);
        this.loaderService.setLoading(false);

        // Check if backend returned an error.message
        const errorMsg =
          err.error?.message || 'Something went wrong. Please try again later.';

        this.sharedService.showMessageDialog(
          errorMsg,
          '',
          SweetAlertIcon.ERROR,
        );
      },
    });
  }
  saveReject() {
    this.modalRefReasons.hide();
    this.reject(this.selectedRowClickedData);
  }
  searchModifiedData: any;
  onMeterConfigFilter(value: any): void {
    this.searchModifiedData = this.searchedValue;

    this.searchModifiedData = this.searchedValue;
    this.meterConfigPageChange({ skip: 0, take: this.pageSize });
    //this.getAllMeterConfigurations();
  }

  public onValueChange(ev: string): void {
    console.log(ev);
    if (ev.length == 0) {
      this.searchModifiedData = '';
      this.meterConfigPageChange({ skip: 0, take: this.pageSize });
      this.getAllDBmeters();
    }
  }

  public onSearchValueChange(value: string): void {
    this.searchedValue = value ?? '';
    this.onValueChange(this.searchedValue);
  }

  onSearchMeterAds(): void {
    if (this.searchedValue.length > 0) {
      this.getAllDBmeters();
    }
  }

  public onMeterFilterChange(filter: CompositeFilterDescriptor): void {
    //  console.log(filter)
    this.meterState.filter = filter;
    this.skip = 0;
    let isFilter = filter.filters.length > 0 ? true : false;
    localStorage.setItem('filter', JSON.stringify(isFilter));
    this.sharedService.setFilter(filter);
    const queryString = this.sharedService.createQuery(this.meterState);
    this.queryString = this.sharedService.createQuery(this.meterState);
    this.getAllDBmeters();
  }


openAgentBulkUpload(): void {
let pageData = {
    title: Templates.CONSUMER.id,
    // projectId: '', 
    isFlag: 'DBmetersAgent',
  };

  this.modalRef = this.modalService.show(RpBulkUpoadComponent, {
    initialState: { pageData },
    ...this.config,
  });

  this.modalRef.content.output.subscribe((response: any) => {
    if (response === 'renderNewData') {
      this.refreshMeterListAfterUpload();
    }
  });
}

  openBulkUpload() {
    let pageData = {
      title: Templates.CONSUMER.id,
      projectId: '',
      isFlag: 'DBmeters',
    };
    this.modalRef = this.modalService.show(RpBulkUpoadComponent, {
      initialState: { pageData },
      ...this.config,
    });
    this.modalRef.content.output.subscribe((response: any) => {
      console.log('Profile data received in header:', response);
      if (response == 'renderNewData') {
        this.refreshMeterListAfterUpload();
      }
      // Handle the received profile data here
    });
  }

  private refreshMeterListAfterUpload(): void {
    this.currentPage = 1;
    this.skip = 0;
    this.searchedValue = '';
    this.searchModifiedData = '';
    this.queryString = '';
    this.orderByQuery = '';
    this.sort = [];
    this.meterState = {
      skip: 0,
      take: this.pageSize,
      sort: [],
      filter: { logic: 'and', filters: [] },
    };
    this.filter = this.meterState.filter;
    this.mySelectionMeter = [];
    this.sharedService.setFilter(this.filter);
    localStorage.setItem('filter', 'false');
    this.getAllDBmeters();
  }
  selectedRowClickedData: any;
  approveRejectConfirmation(dataitem: any, type: string, model: any) {
    this.selectedRowClickedData = dataitem;
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-primary ms-2',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: 'Are you sure?',
        text: ` Do you want to ${type} the meters`,
        icon: 'warning',
        confirmButtonText: 'Yes, Proceed',
        cancelButtonText: 'No, Cancel',
        showCancelButton: true,
      })
      .then((result) => {
        console.log(result);
        console.log(model);
        if (result.value) {
          if (type == 'approve') {
            this.approval(this.selectedRowClickedData);
          } else {
            this.invalidBillsModal(model);
          }
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
        }
      });
  }
  invalidBillsModal(invalidBillModal: any) {
    // this.reason = '';
    this.modalRefReasons = this.modalService.show(invalidBillModal, {
      class: 'modal-dialog-centered',
    });
  }
  validateReason() {
    this.reasonError = this.reason.trim().length === 0;
  }
  
}
